export default {
  name: "SegmentedBar",
  props: {
    value: {
      type: [Number, null],
      required: true,
      default: 0
    },
    color: {
      type: String,
      required: true,
      default: "#312783"
    },
    min: {
      type: Number,
      required: false,
      default: 0
    },
    max: {
      type: Number,
      required: false,
      default: 1
    },
    maxSegments: {
      type: Number,
      required: true,
      default: 20
    }
  },
  computed: {
    numberOfSegments() {
      return this.value * 100 === 0 ? 0 : this.value * 100 <= this.max * 100 / this.maxSegments ? 1 : Math.round(this.value * this.maxSegments * 100 / 100);
    },
    segmentWidth() {
      return {
        width: `${50 / this.maxSegments}%`,
        borderRadius: '2px'
      };
    }
  }
};